module.exports = __webpack_public_path__ + "img/bus-colored-icon.187c2d31.svg";